"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.format = void 0;

var _timeago = require("timeago.js");

/** abstração em cima da biblioteca de timeago */
var localeFunc = function localeFunc(number, index) {
  return [['agora', 'agora'], ['%s seg', 'em %s seg'], ['1 min', 'em 1 min'], ['%s min', 'em %s min'], ['1 h', 'em 1 h'], ['%s h', 'em %s h'], ['1 d', 'em 1 d'], ['%s d', 'em %s d'], ['1 sem', 'em 1 sem'], ['%s sem', 'em %s sem'], ['1 m', 'em 1 m'], ['%s m', 'em %s m'], ['1 a', 'em 1 a'], ['%s a', 'em %s a']][index];
};

var CUSTOM_LOCALE = 'pt_BR';
(0, _timeago.register)(CUSTOM_LOCALE, localeFunc);

var format = function format(date, options) {
  return (0, _timeago.format)(date, CUSTOM_LOCALE, options);
};

exports.format = format;